<template>
  <span
    :class="[
      `m-spinner`,
      {
        'm-spinner--active': active,
        'm-spinner--floating': floating,
      }
    ]"

    aria-hidden="true"
  >
    <inline-image-icons-spinner
      class="m-spinner__svg"
    />
  </span>
</template>

<script>
// Inline
import InlineImageIconsSpinner from 'images/icons/spinner.svg?inline';

// Export
export default {
  name: `module-spinner`,

  // Components
  components: {
    InlineImageIconsSpinner,
  },

  // Props
  props: {
    active: Boolean,
    floating: Boolean,
  },
};
</script>



// WEBPACK FOOTER //
// Spinner.vue?16127bc7